import { useQuery } from '@tanstack/react-query';
import { getJornadasByIdGrupoAndTemporada } from '../../services/jornadasService';

/**
 * Hook para obtener jornadas por grupo y temporada
 * @param {number} idGrupo - ID del grupo
 * @param {number} idTemporada - ID de la temporada
 * @param {object} options - Opciones adicionales de React Query
 */
export const useJornadas = (idGrupo, idTemporada, options = {}) => {
  return useQuery({
    queryKey: ['jornadas', idGrupo, idTemporada],
    queryFn: async () => {
      const navigate = null;
      return await getJornadasByIdGrupoAndTemporada(
        idGrupo,
        idTemporada,
        navigate
      );
    },
    enabled: !!(idGrupo && idTemporada),
    ...options,
  });
};
